import { minPasswordLength } from 'src/components/joinBusiness/validation';
import * as yup from 'yup'

export const validationSchemaEmail = yup.object().shape({
    email: yup.string().required().email(),
})

export const validationSchemaCompanyInformation = yup.object().shape({
    organizationNumber: yup.string().required(),
    companyName: yup.string().required(),
    disallowNewContacts: yup.bool().default(false).isFalse()
})

export const validationSchemaAccount = yup.object().shape({
    firstName: yup.string().required().max(25),
    lastName: yup.string().required().max(25),
    isAuthenticated: yup.bool(),
    password:
        yup.string().when('isAuthenticated', {
            is: false,
            then:
                yup
                    .string()
                    .max(
                        72)
                    .min(
                        minPasswordLength)
                    .required()
        }),
    acceptAccountTerms: yup
        .bool().isTrue(),
    offersByEmail: yup.bool(),
})
